import { useEffect, useState } from 'react';
import { supabase, Portfolio as PortfolioType } from '../../../lib/supabase';

export default function Portfolio() {
  const [portfolios, setPortfolios] = useState<PortfolioType[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPortfolios();
  }, []);

  const loadPortfolios = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase
        .from('portfolios')
        .select('*')
        .order('year', { ascending: false })
        .limit(3);

      if (error) throw error;
      setPortfolios(data || []);
    } catch (error) {
      console.error('포트폴리오 로딩 실패:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="portfolio" className="bg-primary text-white">
      <div className="flex flex-col lg:flex-row min-h-[640px]">
        {/* Left Side - Stats & Info */}
        <div className="lg:w-1/3 p-12 lg:p-16 xl:p-24 border-r border-gray-700 flex flex-col justify-center">
          <span className="text-secondary font-bold tracking-widest mb-4 text-sm">PORTFOLIO</span>
          <h2 className="text-4xl md:text-5xl font-black mb-6 leading-tight">Success Stories</h2>
          <div className="grid grid-cols-2 gap-8 mb-10">
            <div>
              <strong className="text-3xl block mb-1">3,100+</strong>
              <span className="text-gray-300 text-sm">누적 프로젝트</span>
            </div>
            <div>
              <strong className="text-3xl block mb-1">98%</strong>
              <span className="text-gray-300 text-sm">납기 준수율</span>
            </div>
          </div>
          <a 
            href="/portfolio" 
            className="border-2 border-white px-8 py-3 font-bold hover:bg-white hover:text-primary transition cursor-pointer inline-block text-center whitespace-nowrap w-fit"
          >
            전체 보기
          </a>
        </div>

        {/* Right Side - Project Grid */}
        <div className="lg:w-2/3 grid grid-cols-1 md:grid-cols-2">
          {/* Dynamic Portfolio Items */}
          {loading ? (
            <div className="col-span-2 h-80 flex items-center justify-center bg-gray-800">
              <div className="inline-block w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
            </div>
          ) : portfolios.length > 0 ? (
            <>
              {portfolios.map((portfolio) => (
                <div key={portfolio.id} className="relative h-80 group overflow-hidden md:border-l border-t md:first:border-t-0 border-gray-700 cursor-pointer">
                  <div className="w-full h-full bg-gray-800 flex items-center justify-center p-8">
                    {portfolio.logo_url ? (
                      <img 
                        src={portfolio.logo_url} 
                        alt={portfolio.company_name}
                        className="max-w-full max-h-full object-contain transition duration-700 group-hover:scale-110 opacity-70 group-hover:opacity-100"
                      />
                    ) : (
                      <div className="text-gray-600">
                        <i className="ri-building-line text-6xl"></i>
                      </div>
                    )}
                  </div>
                  <div className="absolute bottom-0 left-0 p-8 w-full bg-gradient-to-t from-black via-black/50 to-transparent">
                    <h3 className="text-2xl font-bold">{portfolio.project_name}</h3>
                    <p className="text-sm text-gray-300 mt-2">{portfolio.company_name}</p>
                  </div>
                </div>
              ))}
              {/* More Projects CTA */}
              <a 
                href="/portfolio"
                className="h-80 bg-gray-800 flex items-center justify-center border-t md:border-l border-gray-700 cursor-pointer hover:bg-gray-700 transition group"
              >
                <div className="text-center">
                  <h3 className="text-xl font-bold mb-4">More Projects</h3>
                  <i className="fas fa-arrow-right text-3xl text-secondary group-hover:translate-x-2 transition-transform duration-300"></i>
                </div>
              </a>
            </>
          ) : (
            <div className="col-span-2 h-80 flex items-center justify-center bg-gray-800">
              <div className="text-center">
                <i className="ri-folder-open-line text-6xl text-gray-600 mb-4"></i>
                <p className="text-gray-400">등록된 포트폴리오가 없습니다</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
